import request from '@/utils/request';

/**
 * @description 用户登录(废弃)
 * @param {string}  username
 * @param {string}  password
 * @returns {string} token
 */

export function login(data) {
  return request.post('admin/auth/login', data);
}
/**
 * @description 用户登录
 */

export function userLogin(data) {
  return request.post('admin/auth/user-login', data);
}
/**
 * @description 用户退出登录
 * @returns {string}
 */

export function logout(data) {
  return request.post('/user/logout', data);
}

/**
 * @description 获取验证码
 * @returns {number} code
 */
export function getPhoneCode(data) {
  return request.post('send/sms', data);
}

/**
 * @description 验证验证码
 * @param {string}  phone  手机号
 * @param {string}  code   验证码
 * @returns {string}
 */
export function getCodeTest(data) {
  return request.post('/user/testCode', data);
}

/**
 * @description 获取用户信息
 * @param {string}  token
 * @returns {string} userInfo
 */
export function getInfo(data) {
  return request.post('admin/user/me', data);
}

/**
 * @description 获取用户权限
 * @param {string}  token
 * @returns {string} userInfo
 */
export function getPermissions(data) {
  return request.post('admin/user/permissions', {});
}
/**
 * @description 用户资源
 * @param {string}  token
 * @returns {string} userInfo
 */
export function userResource(data) {
  return request.post('admin/user/resource', data);
}
/**
 * @description 上传当前用户回溯数据
 */
export function uploadTracback(data) {
  return request.post('upload/tracback', data);
}

// 用户对应国家和货币信息
export function getCountryAndCurrencyInfo(data) {
  return request.post('admin/user/getCountryAndCurrencyInfo', data);
}